var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4239 0H2.25631C1.01145 0 0 1.02559 0 2.2846V29.4027C0 30.6617 1.01145 31.6873 2.25631 31.6873H29.4239C30.6688 31.6873 31.6873 30.6617 31.6873 29.4027V2.2846C31.6873 1.02559 30.6688 0 29.4239 0ZM9.57692 27.1606H4.88041V12.0384H9.584V27.1606H9.57692ZM7.22867 9.97302C5.72211 9.97302 4.50554 8.74938 4.50554 7.24989C4.50554 5.7504 5.72211 4.52676 7.22867 4.52676C8.72816 4.52676 9.9518 5.7504 9.9518 7.24989C9.9518 8.75645 8.73523 9.97302 7.22867 9.97302ZM27.1818 27.1606H22.4853V19.8046C22.4853 18.0505 22.4499 15.7941 20.0451 15.7941C17.5978 15.7941 17.2229 17.7039 17.2229 19.6773V27.1606H12.5264V12.0384H17.0319V14.1037H17.0956C17.7251 12.9154 19.2599 11.6635 21.5445 11.6635C26.2976 11.6635 27.1818 14.7968 27.1818 18.8709V27.1606Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0f7db4f04973d85067d1af706be7c600.svg";
export { ForwardRef as ReactComponent };